<form #form="ngForm">
    <plex-int *ngIf="!soloValores" placeholder="Ingrese un valor entre 30 y 200" required="false"
              [(ngModel)]="registro.valor" name="tensionDiastolica" label="Tensión Diastólica" suffix=" mmHG " min="30"
              max="200" (change)="emitChange()">
    </plex-int>

    <p *ngIf="soloValores" class="readonly">
        <span>Tensión Diastólica</span> {{registro.valor}} mmHG
    </p>

    <p *ngIf="mensaje?.texto">
        <plex-badge type="{{mensaje.class}}">
            {{mensaje.texto}}
        </plex-badge>
    </p>
</form>